import { API_TAG, Environment } from './environment.type'

export const environment: Environment = {
  production: false,
  httpInterceptorList: [`https://api.navix.io/${API_TAG}*`],
  env: 'PROD',
  assets: 'https://fpasaprodue01sa.blob.core.windows.net/' + 'assets',
  auth: {
    domain: 'auth.navix.io',
    audience: 'https://navix/api',
    clientId: 'R7gvi1RLR9McPxRlMPJsXkUIpCsa3mEJ',
    apiUri: 'https://fpa-authapi-prod-ue-01-as.azurewebsites.net',
    appUri: 'https://fpa-authapi-prod-ue-01-as.azurewebsites.net',
    errorPath: '/error'
  },
  apis: {
    identity: 'https://api.navix.io/',
    management: `https://api.navix.io/${API_TAG}`,
  },
  apiKey: {
    management: 'ba64975e168442b895901435cb33a34f'
  },
  loginUrl: 'https://app.navix.io' + '/login',
  redirectUrl: 'https://app.navix.io' + '/dashboard',
  pendo: {
    key: 'c883b44e-1006-4016-5805-b6364c43586b'
  },
  appInsights: {
    connectionString: 'InstrumentationKey=71ee8e60-7af8-4408-92fc-2b0d483e66d7;IngestionEndpoint=https://eastus2-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/;ApplicationId=eef1acd9-3324-4db3-badb-87f433ed1c66'
  },
  launchDarkly: {
    clientSideId: '61f9466164ac6a17bae29c13'
  },
  pspdfkit: {
    licenseKey: 'm-h7dBvqsAop7Ouh1oY6jDfEHXhxL-DzK9YLvtyS-2gb8X-mOzRAqekJmXRdWyjoAQaIU05fEkYRa4iZK8Dm1sArobiBFwgshvGFWXgoNcCF-wdAoh97u23_1f5lnlWvxf2fLx6uPywfkhmaktX9qkdrh07QDW8LB4Kvv-AR6kfjuV48wnM9BYscLuB6y6OLfI2DCXSIZBIgArdqyhh4bgzQKaT71eMinypW9rE0mNFtbu_B5Ys6Lt909sQ3xo-GGH6eN19A0cAfmnQBHvoWYwMmka_LkiEY-D5fb-EK4RjZwXupd-mrv87kCdQkmI96-0gbZjsM1iCuTP2bKxZBUkqanhmTRAvY-rRs5jj3D1DqsIB5YyTAxN6Wex9GZ_vGEpAIh1tWLwE0jT1ljkXHR5o0SflCmcLt2SHmbAcJuqJQEwrF8Y_tkAeyGEh0H-awiAih8SfQSZ_uAqXdj2kN0WrskPhj_5GOuGzsKq6_cCO5Nq-XTC0oj-t0qHCNAbD4whVvMCWc-8YgKpXbnf7zg_i9Dp-n5lEGgX9hdfzM5vWz-kGWkbrynADfEcE_ddKK'
  }
}
